import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LoadingSpinner from "./LoadingSpinner";
import { firstAccessiblePage } from "../utils/pageAccess";

const ProtectedRoute = ({ children }) => {
  const { currentUser, userRole, authLoading, settingsLoading, canAccessPage, accessSettings } = useAuth();
  const { pathname } = useLocation();

  if (authLoading || (currentUser && settingsLoading)) {
    return <LoadingSpinner />;
  }

  if (!currentUser) return <Navigate to="/login" replace />;

  // Page switched off for this role by a superadmin — send them somewhere they can go.
  if (!canAccessPage(pathname)) {
    return <Navigate to={firstAccessiblePage(userRole, accessSettings, currentUser?.uid)} replace />;
  }

  return children;
};

export default ProtectedRoute;
